import React, { FC, PropsWithChildren, SyntheticEvent } from 'react'

import { IconChevronFilledDown, IconChevronFilledUp } from '@avantstay/backoffice-vectors'

import * as S from './SortColumnIndicator.styles'

export enum SortDirection {
  Desc = 'descending',
  Asc = 'ascending',
  None = 'none',
}

interface SortColumnIndicatorProps {
  alwaysVisible?: boolean
  className?: string
  sorting?: SortDirection
  onSort: (sort: SortDirection) => void
  reversedOrder?: boolean
}

export const SortColumnIndicator: FC<PropsWithChildren<SortColumnIndicatorProps>> = ({
  alwaysVisible,
  className,
  sorting,
  onSort,
  reversedOrder,
}) => {
  const handleSortChange = (event: SyntheticEvent<HTMLDivElement>) => {
    event?.stopPropagation()
    const options = Object.values(SortDirection)
    if (reversedOrder) {
      options.unshift(...options.splice(1, 1))
    }
    if (sorting && options.indexOf(sorting) > -1) {
      const newSorting = options[(options.indexOf(sorting) + 1) % options.length]
      return onSort(newSorting)
    }

    return onSort(options[0])
  }

  return (
    <S.Root
      className={className}
      onClick={handleSortChange}
      alwaysVisible={alwaysVisible || Boolean(sorting)}
    >
      <S.IndicatorContainer>
        <S.IconWrapper active={sorting === SortDirection.Asc}>
          <IconChevronFilledUp />
        </S.IconWrapper>
        <S.IconWrapper active={sorting === SortDirection.Desc}>
          <IconChevronFilledDown />
        </S.IconWrapper>
      </S.IndicatorContainer>
    </S.Root>
  )
}
